/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Paragraph = {

	delete (context, paragraphId, onSuccess, onError, options) {
		Api.delete(context,
			"/paragraph"
			+ "?paragraphId=" + paragraphId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getLegalFormParagraphList (context, onSuccess, onError, options) {
		Api.get(context,
			"/paragraph/legal-form-paragraph-list"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getList (context, onSuccess, onError, options) {
		Api.get(context,
			"/paragraph/list"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, paragraphDTO, onSuccess, onError, options) {
		Api.post(context,
			"/paragraph"
			, paragraphDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, paragraphDTO, onSuccess, onError, options) {
		Api.put(context,
			"/paragraph"
			, paragraphDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putLegalFormParagraphEdit (context, legalFormParagraphDTO, onSuccess, onError, options) {
		Api.put(context,
			"/paragraph/legal-form-paragraph-edit"
			, legalFormParagraphDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
